import { HttpClient } from "../HttpClient";
/**
 * * Get Contents
 */
export const GetExportExcel = async ({
  dateFrom,
  dateTo,
  assetLabel,
  claimStatus,
  claimant,
}) => {
  try {
    const params = {
      dateFrom,
      dateTo,
      assetLabel,
      ...(claimStatus && { claimStatus }),
      ...(claimant && { claimant }),
    };
    
    const url = `api/contents/ExportExcel?${new URLSearchParams(params).toString()}`;
    
    const { data } = await HttpClient.get(url);
    
    return { data, url };
  } catch (err) {
    return Promise.reject(err);
  }
};
